/**
 * @generated SignedSource<<f506d70b5432de24b8eac90a42245624>>
 * @relayHash 7d65699b292f3495b83e6d7366aa23df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44dd65d9f59cd0156391eb7142ed652780a02e2d8da4803fd8394da5092527b8

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type loomUserPermissionQuery$variables = {
  loomResourceId: string;
  principalId: string;
};
export type loomUserPermissionQuery$data = {
  readonly bulkPermitted: ReadonlyArray<{
    readonly permissionId: string | null;
    readonly permitted: boolean | null;
    readonly principalId: string | null;
    readonly resourceId: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_permission">;
};
export type loomUserPermissionQuery = {
  response: loomUserPermissionQuery$data;
  variables: loomUserPermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loomResourceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "principalId"
},
v2 = {
  "args": [
    {
      "kind": "Literal",
      "name": "permissionIds",
      "value": [
        "write"
      ]
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "principalIds.0",
          "variableName": "principalId"
        }
      ],
      "kind": "ListValue",
      "name": "principalIds"
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "resourceIds.0",
          "variableName": "loomResourceId"
        }
      ],
      "kind": "ListValue",
      "name": "resourceIds"
    }
  ],
  "concreteType": "BulkPermittedResponse",
  "kind": "LinkedField",
  "name": "bulkPermitted",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "principalId"
    },
    {
      "kind": "ScalarField",
      "name": "resourceId"
    },
    {
      "kind": "ScalarField",
      "name": "permissionId"
    },
    {
      "kind": "ScalarField",
      "name": "permitted"
    }
  ]
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "loomUserPermissionQuery",
    "selections": [
      (v2/*: any*/),
      {
        "kind": "InlineDataFragmentSpread",
        "name": "loomPersonalization_permission",
        "selections": (v3/*: any*/),
        "argumentDefinitions": [
          {
            "kind": "RootArgument",
            "name": "loomResourceId"
          },
          {
            "kind": "RootArgument",
            "name": "principalId"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "loomUserPermissionQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7d65699b292f3495b83e6d7366aa23df",
    "id": "44dd65d9f59cd0156391eb7142ed652780a02e2d8da4803fd8394da5092527b8",
    "metadata": {},
    "name": "loomUserPermissionQuery",
    "operationKind": "query",
    "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted},...loomPersonalization_permission}fragment loomPersonalization_permission on Query{bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
  }
};
})();

(node as any).hash = "6960ac36f33e1fcc4b0302c4cf32aae6";

export default node;
